import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ViewClothing from "./pages/ViewClothing";
import ViewOutfits from "./pages/ViewOutfits";
import ViewLookbooks from "./pages/ViewLookbooks";
import AddOutfit from "./pages/AddOutfit";
import EditClothing from "./pages/EditClothing";
import ViewIndividualOutfit from "./pages/ViewIndividualOutfit";
import AddLookbook from "./pages/AddLookbook";
import ViewLookbook from "./pages/ViewLookbook";
import AccountEdit from "./pages/AccountEdit";
import ViewOutfitsByClothing from "./pages/ViewOutfitsByClothing";
import Privacy from "./pages/Privacy";
import NewUserTutorial from "./pages/NewUserTutorial";
import Admin from "./pages/Admin";
import ClothingAnalytics from "./pages/ClothingAnalytics";
import AddWears from "./pages/AddWears";

// Define different route list based on auth level
// TODO: more user roles to be added

// Accessible by any roles
export const NonAuthRoutes = [
	{
		path: "/home",
		element: <Home />,
		exact: true,
	},
	{
		path: "/login",
		element: <Login />,
		exact: true,
	},
	{
		path: "/signup",
		element: <Signup />,
		exact: true,
	},
	{
		path: "/privacy",
		element: <Privacy />,
		exact: true,
	},
];

export const ProtectedRoutes = [
	// Pieces
	{
		path: "/pieces",
		element: <ViewClothing />,
		exact: true,
	},
	{
		path: "/pieces/new",
		element: <EditClothing />,
		exact: true,
	},
	{
		path: "/pieces/:piece_id/edit",
		element: <EditClothing />,
		exact: true,
	},
	{
		path: "/pieces/:piece_id/outfits",
		element: <ViewOutfitsByClothing />,
		exact: true,
	},

	// Outfits
	{
		path: "/outfits",
		element: <ViewOutfits />,
		exact: true,
	},
	{
		path: "/outfits/new",
		element: <AddOutfit />,
		exact: true,
	},
	{
		path: "/outfits/:outfit_id",
		element: <ViewIndividualOutfit />,
		exact: true,
	},
	{
		path: "/outfits/:outfit_id/edit",
		element: <AddOutfit />,
		exact: true,
	},

	// Lookbooks
	{
		path: "/lookbooks",
		element: <ViewLookbooks />,
		exact: true,
	},
	{
		path: "/lookbooks/new",
		element: <AddLookbook />,
		exact: true,
	},
	{
		path: "/lookbook/:lookbook_id",
		element: <ViewLookbook />,
		exact: true,
	},
	{
		path: "/lookbooks/:lookbook_id/edit",
		element: <AddLookbook />,
		exact: true,
	},

	// Misc
	{
		path: "/account",
		element: <AccountEdit />,
		exact: true,
	},
	{
		path: "/welcome",
		element: <NewUserTutorial />,
		exact: true,
	},
	{
		path: "/admin",
		element: <Admin />,
		exact: true,
	},
	{
		path: "/analytics",
		element: <ClothingAnalytics />,
		exact: true,
	},
	{
		path: "/pieces/add_wears",
		element: <AddWears />,
		exact: true,
	},
];
